export const INTERNET_UNRECHABLE_MESSAGE = "Internet connection required. Please connect to the internet."